import DialogsManagement from "./containers";

export default DialogsManagement;